var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 190 190.2",
    style: {
      enableBackground: "new 0 0 190 190.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#01447B;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000166648795031518676470000005614874378649281164_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M81.1,34.4L66,31.7l-17,96.2l77.1,13.6l5.1-28.8c0,0-24.9,3-43.1-16S69.7,55.1,81.1,34.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M132,108.2c-14-0.9-26.5-9.3-32.7-21.9c-15-29.9,16.2-45.9,16.2-45.9l27.7,4.9L132,108.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.5,110.5l-4.3-0.8l-8.2,8.1l4,0.7l1.6-1.7l6.8,1.2l0.8,2.1l4.2,0.7L69.5,110.5z M63.9,115.5l3-3.2l1.7,4.1 L63.9,115.5z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "76.8,111.8 91.6,114.4 91.3,116.1 85.8,115.1 84.5,122.7 80.6,122 82,114.4 76.5,113.4 76.8,111.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M107.9,118.1c-1.7-1.2-3.7-1.9-5.8-2.2c-2-0.5-4.2-0.5-6.2,0c-2,0.5-3.2,1.6-3.5,3.3 c-0.3,1.7,0.4,3.1,2.1,4.3c1.7,1.2,3.7,1.9,5.8,2.2c2,0.5,4.2,0.5,6.2,0c2-0.5,3.1-1.7,3.4-3.3 C110.3,120.8,109.6,119.3,107.9,118.1 M97.1,122.7c-1.2-1-1.3-2.9-0.3-4.1c0.3-0.3,0.7-0.6,1.1-0.8c2.5-0.7,5.2-0.2,7.3,1.3 c1.2,1.1,1.3,2.9,0.2,4.1c-0.3,0.3-0.7,0.6-1.1,0.7c-1.2,0.4-2.5,0.5-3.8,0.2C99.3,124,98.1,123.5,97.1,122.7L97.1,122.7z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "112.1,127.6 113.7,118.3 117.6,119 116.2,126.6 125.3,128.2 125,129.9 112.1,127.6  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M79.6,182.7c-48.4-8.5-80.7-54.6-72.2-103S61.9-1,110.3,7.5s80.7,54.6,72.2,103c0,0,0,0.1,0,0.1 C174,158.8,127.9,191.1,79.6,182.7z M1.5,78.6c-9.1,51.7,25.5,100.9,77.1,110s100.9-25.5,110-77.1c9.1-51.7-25.4-100.9-77.1-110 C59.8-7.6,10.6,26.9,1.5,78.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.5,112.8c0.2,0.6,0.4,1.2,0.7,1.8c1,1.7,2.8,1.9,4.5,1.5c2.2-0.6,3.4-2.2,3-3.7l-0.5-1.7L23.5,112.8  M13.5,115.6c-0.1-0.7-0.2-1.4-0.4-2.2s-0.5-1.4-0.7-2.1l19.3-5.3l1.9,6.9c1.1,3.9,0.1,6.4-3.1,7.3c-5,1.4-7.1-2-8.5-7.1 L13.5,115.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.5,130.2c1.3,2.8,3.3,3.4,5.9,1.8c0.4-0.2,0.8-0.5,1.2-0.9c1.8-1.6,0.5-3.4-0.4-4.9L30.5,130.2  M36.4,121.7l3.1,5.3c0.7,1.2,1.8,3,1.9,4.4c0.2,1.8-0.7,3.5-2.3,4.3c-2.5,1.4-5,0.8-6.8-1.3c-1.6,2.8-3,5.7-4.5,8.6l-1,1.9 c-0.4-0.8-0.8-1.6-1.2-2.4s-1-1.5-1.5-2.2l3.5-6.1c0.5-0.8,1.2-2.2,1.8-3.3l-0.1-0.2l-8.1,4.7c-0.3-0.7-0.6-1.3-1-2 s-0.8-1.2-1.2-1.8L36.4,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41.1,147.3c-2.5,2.9-3.8,7-0.6,9.9s7.8,0.9,11-2.7c2.5-2.8,4-7.2,0.7-10.1C49.2,141.7,45.3,142.4,41.1,147.3  M39.2,158.5c-4.8-4.2-5.6-10-1.3-14.9c3.8-4.4,10.1-5.1,15.5-0.3c6.3,5.5,4.2,11.5,1.3,14.9C51.1,162.4,44.6,163.1,39.2,158.5 L39.2,158.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.7,173.1c-0.7-0.3-1.3-0.7-2-1s-1.4-0.5-2.1-0.7l7.1-16.5c-1.7-0.7-3.4-1.3-5.1-1.8 c0.2-0.3,0.4-0.7,0.6-1.1c0.2-0.4,0.3-0.8,0.4-1.2l13.8,6c-0.2,0.3-0.4,0.7-0.6,1.1c-0.2,0.4-0.3,0.8-0.4,1.2 c-1.5-0.9-3-1.7-4.6-2.4L63.7,173.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.3,159.2c-0.1,0.4-0.3,0.8-0.3,1.2c0,0.4-0.1,0.8-0.1,1.3c-2.1-0.7-4.3-1.2-6.6-1.5l-1,6.2l3,0.5 c1.2,0.2,2.4,0.3,3.6,0.3c-0.1,0.4-0.3,0.8-0.3,1.2c-0.1,0.4-0.1,0.8-0.1,1.3c-1.1-0.4-2.3-0.6-3.5-0.9l-3-0.5l-1.2,7.3 c2.2,0.4,4.5,0.6,6.7,0.7c-0.1,0.4-0.3,0.8-0.3,1.2c-0.1,0.4-0.1,0.8-0.1,1.3l-11-1.9l3.3-19.6L90.3,159.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.2,174.6l-0.4,2.6c-1.7,1-3.6,1.7-5.6,1.8c-6.2,0.6-11.3-2.8-11.9-8.7c-0.7-7.6,4.2-11.6,10.5-12.2 c2.1-0.2,4.1,0.1,6.1,0.9c-0.2,1-0.2,2-0.4,3.1h-0.4c-1.2-1.5-3.1-2.3-5.1-2.2c-4.8,0.5-6.3,5.3-5.9,9.5c0.5,5,3.3,8.2,7.7,7.8 c1.9-0.3,3.7-1.2,5-2.7L111.2,174.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M127.7,172.5c-0.7,0.2-1.4,0.4-2.1,0.7s-1.3,0.6-2,0.9l-6.6-16.7c-1.7,0.7-3.3,1.5-4.9,2.4 c-0.1-0.4-0.2-0.8-0.3-1.2c-0.2-0.4-0.4-0.7-0.6-1.1l14-5.5c0.1,0.4,0.2,0.8,0.3,1.2c0.2,0.4,0.4,0.8,0.6,1.1 c-1.7,0.4-3.4,0.9-5,1.5L127.7,172.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.9,143.9c0.2,0.4,0.4,0.7,0.6,1.1c0.3,0.3,0.5,0.7,0.8,0.9c-2,1-3.9,2.2-5.7,3.6l3.6,5.1l2.5-1.8 c1-0.7,1.9-1.5,2.8-2.3c0.2,0.4,0.4,0.8,0.6,1.1c0.3,0.3,0.5,0.6,0.8,0.9c-1.1,0.5-2.1,1.2-3.1,1.9l-2.5,1.8l4.3,6 c1.8-1.3,3.6-2.7,5.3-4.2c0.2,0.4,0.4,0.8,0.6,1.1c0.3,0.3,0.5,0.7,0.8,0.9l-9.1,6.4l-11.4-16.2L136.9,143.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M156.7,149.5l1.5-1.9c2.5-3.2,2.8-6.8-2.5-11c-4.3-3.4-7.6-2.7-10.1,0.5l-1.8,2.2L156.7,149.5 M145.9,133.9 c4-4.8,9-4.1,12.8-1.1c5.2,4.1,5.4,10.1,1.6,14.8l-5.1,6.3l-15.6-12.3L145.9,133.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtol);
export default __webpack_public_path__ + "static/media/atol.b51f0792978ccaa3b49ae236d2f3bd8d.svg";
export { ForwardRef as ReactComponent };